<template>
  <div class="flex items-center">
    <!-- Light mode logo -->
    <img
      src="@/assets/images/logo-static.svg"
      alt="Hardware Pulse Logo"
      loading="lazy"
      class="h-8 w-auto md:h-10 transition-transform duration-200 hover:scale-105 dark:hidden"
    />
    <!-- Dark mode logo -->
    <img
      src="@/assets/images/logo-dark.svg"
      alt="Hardware Pulse Logo"
      loading="lazy"
      class="h-8 w-auto md:h-10 transition-transform duration-200 hover:scale-105 hidden dark:block"
    />
  </div>
</template>

<script>
  export default {
    name: 'TopLogo',
  };
</script>

<style scoped>
  /* Tailwind CSS handles all styling */
</style>
